import { HStack, Icon } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FaEye, FaEyeSlash, FaInfoCircle } from 'react-icons/fa';

import Popover from '../../Popover';
import Label from '../Label';

const POPOVER_LABEL =
  'We use bank-level AES-256 encryption to protect your information. ' +
  "Don't have a Social Security Number? You can enter an ITIN instead.";

export const LabelWithInfo = ({
  label,
  defaultLabel,
}: {
  defaultLabel: string;
  label?: ReactNode;
}) => {
  return (
    <HStack>
      <Label m={0}>{label || defaultLabel}</Label>
      <Popover placement="auto" label={POPOVER_LABEL} popoverBodyProps={{ textTransform: 'none' }}>
        <span>
          <Icon as={FaInfoCircle} color="bostonBlue" />
        </span>
      </Popover>
    </HStack>
  );
};

export const ShowHideIcon = ({
  show,
  onClick,
  isBlank = false,
}: {
  show: boolean;
  onClick: () => void;
  isBlank?: boolean;
}) => {
  if (isBlank && show) {
    return null;
  }

  return (
    <Icon
      cursor="pointer"
      as={show ? FaEye : FaEyeSlash}
      color="grayMedium"
      fontSize="16px"
      onClick={onClick}
    />
  );
};
